/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_Preview_Forced_UpdateInputs */

const en_mobile_dev_preview_forced_update = /** @type {(inputs: Mobile_Dev_Preview_Forced_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview forced update`)
};

const es_mobile_dev_preview_forced_update = /** @type {(inputs: Mobile_Dev_Preview_Forced_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de actualización forzada`)
};

/**
* | output |
* | --- |
* | "Preview forced update" |
*
* @param {Mobile_Dev_Preview_Forced_UpdateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_preview_forced_update = /** @type {((inputs?: Mobile_Dev_Preview_Forced_UpdateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_Preview_Forced_UpdateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_preview_forced_update(inputs)
	return en_mobile_dev_preview_forced_update(inputs)
});